import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { authenticationService } from '../../services/security/authenticationService';
import { authStorage } from '../../services/security/authStorage';
import { loginRequest } from '../../store/actions';
import Login from './Login';

const LoginContainer = props => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [authUrl, setAuthUrl] = useState('');
  const [adminLoginView, setAdminLoginView] = useState(false);
  const loginStarted = useRef(false);
  const postLoginDestination = useRef(null);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'username') {
      setUsername(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
    props.login({ username, password });
  };
  const toggleView = showAdminLogin => {
    setAdminLoginView(showAdminLogin);
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    let code = params.get('code');
    const returnUrlFromQuery = params.get('returnUrl');

    // Legacy: code was nested as /login?returnUrl=/?code=... after root OAuth redirect
    if (!code && returnUrlFromQuery) {
      try {
        const nested = new URL(returnUrlFromQuery, window.location.origin);
        code = nested.searchParams.get('code');
      } catch (err) {
        // ignore malformed returnUrl
      }
    }

    // Never persist an OAuth callback URL as the post-login destination
    if (returnUrlFromQuery && !returnUrlFromQuery.includes('code=')) {
      authStorage.savePostLoginRedirect(returnUrlFromQuery);
    }

    const fetchData = async () => {
      if (props.isLoggedIn) return;

      if (!code) {
        const { data } = await authenticationService.getOfficeAuthUrl();
        setAuthUrl(data.data);
        return;
      }

      // OAuth codes are single-use; avoid double-exchange in Strict Mode
      if (loginStarted.current) return;
      loginStarted.current = true;
      props.login({ code });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (props.isLoggedIn) {
    if (postLoginDestination.current === null) {
      postLoginDestination.current = authStorage.consumePostLoginRedirect();
    }
    return <Redirect to={postLoginDestination.current} />;
  }

  return (
    <Login
      authUrl={authUrl}
      isLoading={props.isLoading}
      unauthorized={props.unauthorized}
      unknownError={props.unknownError}
      invalidUser={props.invalidUser}
      handleChange={handleChange}
      login={handleSubmit}
      adminLoginView={adminLoginView}
      toggleView={toggleView}
    />
  );
};

const mapStateToProps = store => ({
  currentUser: store.auth.currentUser,
  isLoading: store.auth.isLoading,
  unauthorized: store.auth.unauthorized,
  unknownError: store.auth.unknownError,
  invalidUser: store.auth.invalidUser,
  isLoggedIn: store.auth.isLoggedIn
});
const mapDispatchToProps = {
  login: loginRequest
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
